import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuDivider = styled(Divider)(({ theme }) => ({
  marginLeft: '20px',
  marginRight: '20px',
  marginTop: '8px',
  marginBottom: '8px',
  borderColor: theme.palette.menu.color,
}));
